import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { AnySpendDeposit } from "./AnySpendDeposit.js";
export function AnySpendWorkflowTrigger({
  recipientAddress,
  chainId,
  tokenAddress,
  amount,
  workflowId,
  orgId,
  callbackMetadata,
  onSuccess,
  onClose,
  mode,
  actionLabel,
  classes,
  showFiatOption
}) {
  const metadata = useMemo(() => ({
    workflowId,
    orgId,
    ...callbackMetadata
  }), [workflowId, orgId, callbackMetadata]);
  return _jsx(AnySpendDeposit, {
    recipientAddress: recipientAddress,
    destinationTokenAddress: tokenAddress,
    destinationTokenChainId: chainId,
    destinationTokenAmount: amount,
    callbackMetadata: metadata,
    onSuccess: onSuccess,
    onClose: onClose,
    mode: mode,
    actionLabel: actionLabel,
    classes: classes,
    allowDirectTransfer: true,
    showFiatOption: showFiatOption
  });
}